const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Děkujeme za registraci",
      content:
        "Vítejte,<br/>děkujeme za registraci. S potěšením Vám oznamujeme, že Vaše registrace na BRIDGESTONE PLUS byla zkontrolována a schválena.<br/>Věříme, že Vám BRIDGESTONE PLUS přinese úspěch a cenné informace, a těšíme se na další spolupráci.<br/>S pozdravem,<br/>Tým BRIDGESTONE PLUS",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Děkujeme za registraci",
      content:
        "Vítejte,<br/>děkujeme za registraci. S potěšením Vám oznamujeme, že Vaše registrace na BRIDGESTONE PLUS byla zkontrolována a schválena.<br/>Věříme, že Vám BRIDGESTONE PLUS přinese úspěch a cenné informace, a těšíme se na další spolupráci.<br/>S pozdravem,<br/>Tým BRIDGESTONE PLUS",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: {
      title: "",
      content: "",
    },
  },
};

export default {
  messages,
};
